<template>
  <div class="appPublish">
    <div class="header">
      <div class="search" style="width: 60%">
        <el-select
          class="search-select"
          v-model="formInline.type"
          clearable
          placeholder="请选择"
        >
          <el-option
            v-for="item in globalStatus"
            :key="item.type"
            :label="item.name"
            :value="item.type"
          >
          </el-option>
        </el-select>
        <el-input
          class="search-input"
          style="width: 200px"
          v-model="formInline.name"
          placeholder="请输入要查询关键字"
        ></el-input>
        <el-button icon="el-icon-search" size="small" @click="onSearch"
          >查询</el-button
        >
        <el-button size="small" @click="onRefresh" icon="el-icon-refresh"
          >刷新</el-button
        >
      </div>
      <div>
        <el-button-group>
          <el-button
            type="primary"
            icon="el-icon-plus"
            @click="onAdd"
            v-if="roleList[path].includes('_Add')"
            >新增</el-button
          >
        </el-button-group>
      </div>
    </div>

    <el-table
      v-loading="listLoading"
      height="750"
      :data="tableData"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
    >
      <el-table-column align="center" width="50" label="编号">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
        </template>
      </el-table-column>

      <el-table-column label="版本号" width="90" align="center">
        <template slot-scope="scope">
          {{ scope.row.version }}
        </template>
      </el-table-column>

      <el-table-column label="发布时间" width="160" align="center">
        <template slot-scope="scope">
          {{ scope.row.publishTime }}
        </template>
      </el-table-column>

      <el-table-column label="下载地址" width="250" align="center">
        <template slot-scope="scope">
          {{ scope.row.href }}
        </template>
      </el-table-column>

      <el-table-column label="升级内容" width="300" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.remark }}</span>
        </template>
      </el-table-column>

      <el-table-column class-name="status-col" label="类型" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.type === 1 ? 'success' : 'info'">{{
            scope.row.type | globalStatusFilter
          }}</el-tag>
        </template>
      </el-table-column>

      <!-- <el-table-column class-name="status-col" label="添加人" align="center">
                <template slot-scope="scope">
                    {{ scope.row.createBy }}
                </template>
            </el-table-column>
            <el-table-column class-name="status-col" width="160" label="添加时间" align="center">
                <template slot-scope="scope">
                    {{ scope.row.createTime }}
                </template>
            </el-table-column>
            <el-table-column class-name="status-col" label="修改人" align="center">
                <template slot-scope="scope">
                    {{ scope.row.updateBy }}
                </template>
            </el-table-column>
            <el-table-column class-name="status-col" width="160" label="修改时间" align="center">
                <template slot-scope="scope">
                    {{ scope.row.updateTime }}
                </template>
            </el-table-column> -->

      <el-table-column label="操作" width="100" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button
            type="text"
            size="mini"
            @click="edit(scope)"
            v-if="roleList[path].includes('_Update')"
            >编辑</el-button
          >
          <el-button
            type="text"
            size="mini"
            @click="deleteItem(scope)"
            v-if="roleList[path].includes('_Delete')"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <Pagination ref="Pagination" />

    <!-- 修改表单对话框 -->
    <editForm ref="editForm" />
  </div>
</template>

<script>
const editForm = () => import('./editForm'); // 表单
import Pagination from '@/components/Pagination'; // 分页
import { appRemove, appList } from '@/api/appPublishApi.js';
import { mapGetters } from 'vuex';
var that;
export default {
  components: {
    Pagination,
    editForm,
  },
  inject: ['reload'],
  mounted() {
    this.getList();
  },
  data() {
    return {
      listLoading: false,
      tableData: [],
      formInline: {
        name: '',
        type: '',
      },
      pageIndex: 1,
      pageSize: 10,
      path: '',
      globalStatus: [
        {
          type: 1,
          name: '苹果',
        },
        {
          type: 0,
          name: '安卓',
        },
      ],
    };
  },
  computed: {
    ...mapGetters(['paginObj', 'roleList']),
  },
  beforeCreate() {
    that = this;
  },
  created() {
    const arr = this.$route.path.split('/');
    this.path = arr[arr.length - 1];
  },
  filters: {
    globalStatusFilter(type) {
      const obj = that.globalStatus.find((obj) => obj.type === type);
      // 非空返回对应的名称
      return obj ? obj.name : null;
    },
  },
  watch: {
    paginObj: 'getList',
  },
  methods: {
    // 获取数据的方法
    async getList() {
      this.listLoading = true;
      await appList({
        pageSize: this.paginObj.pageSize,
        pageIndex: this.paginObj.pageIndex,
        name: this.formInline.name,
        type: this.formInline.type,
      }).then((res) => {
        this.tableData = res.data ? res.data.dataList : [];
        this.listLoading = false;
        this.pageIndex = res.data.pageIndex;
        this.pageSize = res.data.pageSize;
        this.$refs.Pagination.pageSize = res.data.pageSize;
        this.$refs.Pagination.pageIndex = res.data.pageIndex;
        this.$refs.Pagination.totalCount = res.data.totalCount;
      });
    },
    // 刷新当前页面
    onRefresh() {
      this.reload();
    },
    // 搜索
    onSearch() {
      this.getList();
    },
    // 增加
    onAdd() {
      this.$refs.editForm.publishId = '';
      this.$refs.editForm.dialogTitle = '新增APP版本发布';
      this.$refs.editForm.dialogFormVisible = true;
    },
    // 单条编辑
    edit(scope) {
      this.$refs.editForm.publishId = scope.row.publishId;
      this.$refs.editForm.dialogTitle = '编辑APP版本发布';
      this.$refs.editForm.dialogFormVisible = true;
      this.$refs.editForm.editForm = JSON.parse(JSON.stringify(scope.row));
    },
    // 单条删除
    deleteItem(scope) {
      const item = scope.row;
      this.funcRemove(item.publishId);
    },
    funcRemove: function (publishId) {
      try {
        if (publishId.length === 0)
          return this.$message.error('请选择要删除的数据');
        this.$confirm('是否狠心删除该数据', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'error',
        })
          .then(async () => {
            await appRemove(publishId).then((res) => {
              if (res.code === 200) {
                this.onRefresh();
                this.$message.success('删除成功!');
              } else {
                this.$message.info('删除失败：' + res.message);
              }
            });
          })
          .catch(() => {
            this.$message.info('删除出错');
          });
      } catch (e) {
        this.$message.info('删除出错:' + e.message);
        window.console.log(e);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.appPublish {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;

  .search {
    display: flex;
    width: 800px;

    .search-input {
      margin: 0 10px;
      width: 300px;
    }

    .search-picker {
      width: 250px;
    }

    .search-select {
      margin-right: 10px;
    }
  }

  button {
    height: 40px;
  }
}
.btn {
  display: flex;
  align-items: center;
}
/deep/ .el-checkbox__input {
  margin-left: 10px;
}
</style>
